import { render, staticRenderFns } from "./PointGoodsItem.vue?vue&type=template&id=028f472b&scoped=true&"
import script from "./PointGoodsItem.vue?vue&type=script&lang=js&"
export * from "./PointGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./PointGoodsItem.vue?vue&type=style&index=0&id=028f472b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f472b",
  null
  
)

export default component.exports